import { render, staticRenderFns } from "./BusinessMemberDocumentDelete.vue?vue&type=template&id=49eb0105"
import script from "./BusinessMemberDocumentDelete.vue?vue&type=script&lang=js"
export * from "./BusinessMemberDocumentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports